import { ContentItem } from '@obeta/data/lib/hooks/useArticleGalleryContent'

export type GalleryModalProps = {
  open: boolean
  items: ContentItem[]
  selectedIdx: number
  onClose?: () => void
}

export enum MediaContentTypes {
  All = 'All',
  Builder = 'builder',
  ThreeDView = 'threeDView',
  Video = 'video',
}
